import { render, staticRenderFns } from "./taskConflictDialog.vue?vue&type=template&id=c2bc7014&"
import script from "./taskConflictDialog.vue?vue&type=script&lang=js&"
export * from "./taskConflictDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports